import { useLayoutEffect, useState } from "react";
import QRCode from 'qrcode.react';

/** 桌布活動國際版（香港 / 新加坡等）的電腦版提示文案。 */
const WALLPAPER_DESKTOP_HINT = {
	zh: "請使用手機掃描上方 QR Code\n開啟活動頁面",
	en: "Please scan the QR code above\nwith your mobile device to join",
};

/**
 * 從 /desktop 的網址參數判斷是否為桌布活動國際版（由 App.jsx 導向時帶入）。
 * 是的話回傳 QR Code 連結（帶回原本的 lang / country）與文案語系。
 */
const getWallpaperIntl = () => {
	const params = new URLSearchParams(window.location.search);
	if (params.get("campaign") !== "wallpaper") return null;

	const query = new URLSearchParams();
	["lang", "country"].forEach((key) => {
		const value = params.get(key);
		if (value) query.set(key, value);
	});
	const search = query.toString();
	return {
		url: `${window.location.origin}/wallpaper/home${search ? `?${search}` : ""}`,
		lang: params.get("lang") === "en" ? "en" : "zh",
	};
};

export const DesktopPage = () => {
	const [navContainerClass, setNavContainerClass] = useState("");
	const [navClass, setNavClass] = useState("");
	const [qrcodeClass, setQrcodeClass] = useState("");
	const [lineClass, setLineClass] = useState("");
	const liffUrl = process.env.REACT_APP_LIFF_URL;
	const [wallpaperIntl] = useState(getWallpaperIntl);

	useLayoutEffect(() => {
		window.addEventListener("resize", handleResize);
		handleResize();
		return () => window.removeEventListener("resize", handleResize);
	}, []);

	const handleResize = () => {
		if (window.innerWidth >= 720) {
			setNavContainerClass("py-[100px]");
			setNavClass("w-[558px] h-auto");
			setQrcodeClass("w-[274px] h-[274px]");
			setLineClass("w-[302px] h-auto mt-24");
		} else {
			setNavContainerClass("py-[20vw]");
			setNavClass("w-[77vw] h-auto");
			setQrcodeClass("w-[38vw] h-[38vw]");
			setLineClass("w-[42vw] h-auto mt-24");
		}
	};

	return (
		<div className={"flex flex-col items-center justify-center"}>
			<div className={navContainerClass}>
				<img
					className={navClass}
					alt={"top-nav"}
					src={"/images/liff/desktop-page/nav.png"}
				/>
			</div>
			<div className={qrcodeClass}>
      	<QRCode value={wallpaperIntl?.url ?? liffUrl} size='256' style={{width:'100%', height:'100%'}} />
			</div>
			{wallpaperIntl ? (
				<p className={`${lineClass} text-center whitespace-pre-line`}>
					{WALLPAPER_DESKTOP_HINT[wallpaperIntl.lang]}
				</p>
			) : (
				<img
					className={lineClass}
					alt={"qr-code"}
					src={"/images/liff/desktop-page/line.png"}
				/>
			)}
		</div>
	);
};
